import type { ReactElement } from "react";
import { DashboardsModuleMenu } from "#app/components/dashboards/dashboards-module-menu";
import { HomeModuleMenu } from "#app/components/home/home-module-menu";
import { MapModuleMenu } from "#app/components/map/map-module-menu";
import { TeamsModuleMenu } from "#app/components/teams/teams-module-menu";
import { WorkflowsModuleMenu } from "#app/components/workflows/workflows-module-menu";
import type { ModuleRailTileId } from "./module-rail";

/**
 * The one tile-id → module-menu mapping. The workspace layout resolves the
 * sidebar pane through it, and the collapsed rail's hover flyout renders the
 * hovered module's menu through the same door — the two must never disagree
 * about what a module's menu is.
 */
export function ModuleMenuForTile({
  tileId,
}: {
  tileId: ModuleRailTileId | null;
}): ReactElement | null {
  switch (tileId) {
    case "home":
      return <HomeModuleMenu />;
    case "map":
      return <MapModuleMenu />;
    case "workflows":
      return <WorkflowsModuleMenu />;
    case "dashboards":
      return <DashboardsModuleMenu />;
    case "teams":
      return <TeamsModuleMenu />;
    default:
      return null;
  }
}
